import { render, staticRenderFns } from "./spaceInfoDialog.vue?vue&type=template&id=2e256cd0"
import script from "./spaceInfoDialog.vue?vue&type=script&lang=js"
export * from "./spaceInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports